import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { OpeningDay, PropertyUpdate } from "../types/property";

type PropertyManagementSlice = {
  property: PropertyUpdate;
  originalProperty: PropertyUpdate | null;
};

const initialState: PropertyManagementSlice = {
  property: {
    customerId: "",
    isSevdeskProperty: false,
    name1: "",
    name2: "",
    street: "",
    postcode: "",
    city: "",
    remark: "",
    openingHours: [],
  },
  originalProperty: null,
};

export const propertyManagementSlice = createSlice({
  name: "propertyManagement",
  initialState,
  reducers: {
    setCustomerId: (state, { payload }: PayloadAction<string>) => {
      state.property.customerId = payload;
    },
    setPropertyName: (state, { payload }: PayloadAction<string>) => {
      state.property.name1 = payload;
    },
    setAdditionalName: (state, { payload }: PayloadAction<string>) => {
      state.property.name2 = payload;
    },
    setStreet: (state, { payload }: PayloadAction<string>) => {
      state.property.street = payload;
    },
    setPostcode: (state, { payload }: PayloadAction<string>) => {
      state.property.postcode = payload;
    },
    setCity: (state, { payload }: PayloadAction<string>) => {
      state.property.city = payload;
    },
    setRemark: (state, { payload }: PayloadAction<string>) => {
      state.property.remark = payload;
    },
    setOpeningHours: (state, action: PayloadAction<OpeningDay[]>) => {
      state.property.openingHours = action.payload;
    },
    setEditProperty(state, { payload }: PayloadAction<any>) {
      state.property = structuredClone(payload);
      state.originalProperty = structuredClone(payload);
    },
    resetState() {
      return { ...initialState };
    },
  },
});

export const propertyManagementActions = propertyManagementSlice.actions;
